/**
 * Drop-down selection control.
 *
 * ## Properties
 * Name | Description
 * --- | ---
 * value | The current selection.
 *
 * ## Events
 * Name | Arguments | Description
 * --- | --- | ---
 * change | The current selection. | Fires whenever the selected value changes.
 * @module app/views/SelectView
 */
import Backbone from "backbone";
import _ from "underscore";
var SelectView = Backbone.View.extend({
  tagName: "select",
  className: "form-control",
  template: _.template(
    '<% _.each(items, function(item){%><option value="<%= item.value%>" <% if(value==item.value){%>selected="selected"<%}%>><%= item.text%><%})%>'
  ),
  /**
   * Initializes a selection control.
   * @param  {object} options The options hash.
   * @param {Array} options.items An array of objects with `value` and `text` properties, where `text` is the text for the item and `value` is the underlying value.
   * @param {string} [options.value] The value to initially select in the control.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      items: [], //array of objects with key: string, value: string
      value: "", //selected value - should be one of the keys in items.
    });

    this._value = this.options.value;
    var self = this;

    this.$el.addClass(options.class);

    Object.defineProperty(this, "value", {
      get: function () {
        return self._value;
      },
      set: function (value) {
        self._value = value;
        self.$el.val(value);
      },
    });
  },

  events: {
    change: function () {
      this._value = this.$el.val();
      this.trigger("change", this._value);
    },
  },

  render: function () {
    this.$el.html(this.template(this.options));
  },

  /**
   * Enable the button.
   */
  enable: function () {
    this.$el.removeAttr("disabled");
  },

  /**
   * Disable the button.
   */
  disable: function () {
    this.$el.attr("disabled", "disabled");
  },
});

export default SelectView;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/SelectView.js
// module id = 350
// module chunks = 1